import { Report } from '@mi-front/core';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import React from 'react';
import { Page } from '../../../../../components/page/Page';
import { GlobalReportsBreadcrumbs } from '../../../components/breadcrumbs';

export function BaseReportPage({
  report,
  children,
  headerActions,
}: {
  report: Report;
  children: React.ReactNode;
  headerActions?: React.ReactNode;
}) {
  const title = report.name;

  return (
    <Page htmlTitle={title}>
      <Page.Header
        title={title}
        icon={<DescriptionOutlinedIcon />}
        breadcrumbs={<GlobalReportsBreadcrumbs showCreatedReports />}
        actions={headerActions}
      />
      <Page.Content>{children}</Page.Content>
    </Page>
  );
}
